(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

var boolean = require('boolean');
var zxcvbn = require('zxcvbn');

module.exports.validate = function validate(password, user) {
    user = user || {};
    password = password || '';
    var additionalInputs = ['catalytic', 'pushbot', user.username, user.email, user.fullName, user.teamName, user.userID].filter(function (i) {
        return i;
    });

    var verification = zxcvbn(password, additionalInputs);
    password = password.toLowerCase(); // lower case password for matching
    var result = {
        score: verification.score,
        rawVerification: verification,
        tooShort: password.length < 8,
        containsEmail: boolean(user.email && password.indexOf(user.email.toLowerCase()) !== -1),
        containsUsername: boolean(user.username && password.indexOf(user.username.toLowerCase()) !== -1),
        containsUserID: boolean(user.userID && password.indexOf(user.userID.toLowerCase()) !== -1),
        containsFullName: boolean(user.fullName && password.indexOf(user.fullName.toLowerCase()) !== -1),
        containsCatalytic: boolean(password.indexOf('catalytic') !== -1),
        containsPushbot: boolean(password.indexOf('pushbot') !== -1),
        containsTeamName: boolean(user.teamName && password.indexOf(user.teamName.toLowerCase()) !== -1)
    };

    Object.getOwnPropertyNames(result).filter(function (name) {
        return name.startsWith('contains');
    }).forEach(function (name) {
        if (result[name] === true) {
            result.score = Math.max(result.score - 1, 0);
        }
    });

    result.valid = result.score > 2;

    return result;
};

})));
//# sourceMappingURL=index.js.map
